import React from 'react';
import Gourdex from './components/Gourdex.js';

export default function App() {
  return <Gourdex />;
}
